import { Route, Routes } from "react-router-dom";

import PaymentIntegrationCreateScreen from "screens/App/CRM/PaymentIntegration/PaymentIntegrationCreateScreen";
import PaymentIntegrationDetailScreen from "screens/App/CRM/PaymentIntegration/PaymentIntegrationDetailScreen";
import PaymentIntegrationEditScreen from "screens/App/CRM/PaymentIntegration/PaymentIntegrationEditScreen";
import PaymentIntegrationListScreen from "screens/App/CRM/PaymentIntegration/PaymentIntegrationListScreen";
import { NotFoundScreen } from "screens/NotFoundScreen";

const PaymentIntegrationRouter = () => {
  return (
    <Routes>
      <Route path="create" element={<PaymentIntegrationCreateScreen />} />
      <Route path=":id/edit" element={<PaymentIntegrationEditScreen />} />
      <Route path=":id/detail" element={<PaymentIntegrationDetailScreen />} />
      <Route path="list" element={<PaymentIntegrationListScreen />} />
      <Route path="*" element={<NotFoundScreen />} />
    </Routes>
  );
};

export default PaymentIntegrationRouter;